<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <h1>Tutorial</h1>
        <p>
          <video
            controls
            src="../../media/FIVEx_tutorial_1.mp4"
            type="video/mp4"
          >
            Your browser does not support the HTML5 Video element.
          </video>
        </p>
        <p>
          <video
            controls
            src="../../media/FIVEx_tutorial_2.mp4"
            type="video/mp4"
          >
            Your browser does not support the HTML5 Video element.
          </video>
        </p>
        <p>
          <video
            controls
            src="../../media/FIVEx_tutorial_3.mp4"
            type="video/mp4"
          >
            Your browser does not support the HTML5 Video element.
          </video>
        </p>
        <p>
          <video
            controls
            src="../../media/FIVEx_tutorial_4.mp4"
            type="video/mp4"
          >
            Your browser does not support the HTML5 Video element.
          </video>
        </p>
        <p>
          <video
            controls
            src="../../media/FIVEx_tutorial_5.mp4"
            type="video/mp4"
          >
            Your browser does not support the HTML5 Video element.
          </video>
        </p>
        <p>
          <video
            controls
            src="../../media/FIVEx_tutorial_6.mp4"
            type="video/mp4"
          >
            Your browser does not support the HTML5 Video element.
          </video>
        </p>
        <p><small>&copy; {{ (new Date()).getFullYear() }} - The University of Michigan, Center for Statistical Genetics</small></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Tutorial',
};
</script>

<style scoped>

</style>
